import React from "react";
import { useRegisterContext } from "../../context/ContextProvider";

const SpendStep2 = ({ text }) => {
	const { activeStyle, setActiveStyle } = useRegisterContext();

	return (
		<form className="container spend__form-step2">
			<p className="step__title">{text}</p>
			<div className="building__type">
				<input type="text" placeholder="Lagos, ikeja" required />
				<button
					type="submit"
					className="building__type-button"
					onClick={() => setActiveStyle(activeStyle + 1)}
				>
					Next
				</button>
			</div>
		</form>
	);
};

export default SpendStep2;
